module.exports = __webpack_public_path__ + "img/figure01_sp.9b41b0c7.png";